import React, { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  Collapse,
  RadioGroup,
  FormControlLabel,
  Radio,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  InputAdornment,
  Checkbox,
  Dialog,
  DialogContent,
  Snackbar,
  Alert
} from '@mui/material';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import GooglePlaces from '../GooglePlaces';

import { MultiInputTimeRangeField, LocalizationProvider } from '@mui/x-date-pickers-pro';
import { renderTimeViewClock } from '@mui/x-date-pickers/timeViewRenderers';

import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

import Iconify from '../Iconify';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import { api } from 'src/Api';
import GooglePlacesFilter from '../GooglePlacesFilter';
import {
  GoogleMap,
  useJsApiLoader,
  DirectionsRenderer,
  Polyline,
  Marker,
  OverlayView,
  useLoadScript
} from '@react-google-maps/api';
import LocationPickerMap from '../LocationPickerMap';
import ProjectManagerDropdown from '../ProjectManagerDropdown';
import JobGroupEditAdd from '../JobGroupEditAdd';
import { use } from 'react';
import CustomTimePicker from '../TimePickcer';

const ShipmentDetailsForm = ({
  postOpen,
  formData,
  errors,
  handlePostOpen,
  handleChangevalue,
  handleTimeChange,
  handleDateChange,
  onResultAddress,
  MAX_COMMENT_LENGTH,
  handleChangeRadio,
  handleCheckboxChange,
  onResultAddressDestination,
  disabled,
  setFormData,
  detail_id,
  convertedLength,
  convertedWeight
}) => {
  const [equipmentList, setEquipmentList] = useState([]);
  const [commondityList, setCommodityList] = useState([]);
  const [contactList, setContactList] = useState([]);
  const [mapOpen, setMapOpen] = useState(false);
  const [locationType, setLocationType] = useState(''); // 'origin' or 'destination'
  const [saveLoading, setSaveLoading] = useState(false);

  const [selectedContact, setSelectedContact] = useState([]);

  const [contactAddModal, setContactAddModal] = useState({ open: false, mode: 'add', value: '' });

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  useEffect(() => {
    getEquipments();
    getCommodity();
    getContact();
  }, []);

  function getEquipments() {
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.get_equipments, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setEquipmentList(result.data);
      })
      .catch((error) => console.log('error', error));
  }

  function getCommodity() {
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.get_commodities, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setCommodityList(result.data);
      })
      .catch((error) => console.log('error', error));
  }

  function getContact() {
    const myHeaders = new Headers();

    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow'
    };

    fetch(api.get_contact_list, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setContactList(result.data);
      })
      .catch((error) => console.log('error', error));
  }

  const handleLocationIconClick = (type) => {
    setLocationType(type);
    setMapOpen(true);
    // if (type === 'origin' && formData?.origin) {
    //   setSelectedLocation({ lat: formData?.origin?.lat, lng: formData?.origin?.lon });
    // } else if (type === 'destination' && formData?.destination) {
    //   setSelectedLocation({ lat: formData?.destination?.lat, lng: formData?.destination?.lon });
    // }
  };

  const handleSelectLocation = (type, locationData) => {
    setFormData((prev) => ({
      ...prev,
      [type]: locationData
    }));
    setMapOpen(false);
  };

  function handleJobGroupSave({ id, name }) {
    setSaveLoading(true);
    const token = localStorage.getItem('token');
    const myHeaders = new Headers();
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    name && formData.append('contact_no', name);
    id && formData.append('id', id);

    const requestOptions = {
      method: 'POST',
      redirect: 'follow',
      headers: myHeaders,
      body: formData
    };

    fetch(api.add_edit_contact_list, requestOptions)
      .then((response) =>
        response.text().then((result) => ({ status: response.status, body: result }))
      )
      .then(({ status, body }) => {
        const result = JSON.parse(body);
        if (status === 200 || status === 201) {
          setSnackbarMessage(result.message);
          setSnackbarSeverity('success');
          setSnackbarOpen(true);
          getContact();
          if (contactAddModal.mode !== 'add') {
            setSelectedContact([id]);
          }
          setContactAddModal({ ...contactAddModal, open: false });
        } else {
          setSnackbarMessage(result.errors);
          setSnackbarSeverity('error');
          setSnackbarOpen(true);
        }
      })
      .catch((error) => {
        setSnackbarMessage(error?.errors);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        console.log('error', error);
      })
      .finally(() => {
        setSaveLoading(false);
      });
  }

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <Box
      sx={{ boxShadow: '0px 4px 5px rgba(0, 0, 0, 0.1)', mt: 2 }}
      style={{
        borderRadius: 6,
        borderBottomLeftRadius: postOpen ? 6 : 6,
        borderBottomRightRadius: postOpen ? 6 : 6
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          cursor: 'pointer',
          backgroundColor: '#010f58',
          height: 40,
          padding: '0px 15px 0px 15px'
        }}
        style={{
          borderRadius: 6,
          borderBottomLeftRadius: postOpen ? 0 : 6,
          borderBottomRightRadius: postOpen ? 0 : 6
        }}
        onClick={handlePostOpen}
      >
        <Typography
          variant="overline"
          sx={{ flex: 1, fontSize: 13, textTransform: 'capitalize', color: '#ffffff' }}
        >
          Shipment Details
        </Typography>
        {postOpen ? (
          <ExpandLess sx={{ color: '#ffffff' }} />
        ) : (
          <ExpandMore sx={{ color: '#ffffff' }} />
        )}
      </Box>

      <Box>
        <Collapse in={postOpen}>
          <Box
            sx={{ flexWrap: 'nowrap', padding: '0px 15px 0px 15px' }}
            style={{
              borderBottomLeftRadius: postOpen ? 6 : 0,
              borderBottomRightRadius: postOpen ? 6 : 0
            }}
          >
            <Typography
              variant="h6"
              sx={{
                marginTop: 2,
                borderBottom: '2px solid #010f58',
                paddingBottom: 0.5,
                marginBottom: 2,
                color: '#010f58'
              }}
            >
              Location
            </Typography>

            <Grid container spacing={2} mb={2}>
              <Grid item spacing={2} xs={12} sm={4.3} md={4.9}>
                <GooglePlaces
                  width={'100%'}
                  onResult={onResultAddress}
                  placeholder={'Origin (City/ST/ZIP) -'}
                  // regions={true}
                  address={formData?.origin?.address}
                  error={Boolean(errors.origin)}
                  helperText={errors.origin}
                  disabled={disabled}
                />
                {!disabled && (
                  <div
                    style={{
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: 5
                    }}
                    onClick={() => handleLocationIconClick('origin')}
                  >
                    <Iconify icon="mdi:location" style={{ color: '#010f58', fontSize: 20 }} />
                    <p style={{ fontSize: 13, color: '#666', marginLeft: 5 }}>
                      Set Location on map
                    </p>
                  </div>
                )}
              </Grid>

              {/* {!disabled && (
                <Grid
                  item
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '20px',
                    marginTop: 1
                  }}
                >
                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleLocationIconClick('origin')}
                  >
                    <Iconify icon="mdi:location" style={{ color: '#010f58', fontSize: 20 }} />
                  </div>
                </Grid>
              )} */}

              <Grid item xs={12} sm={1} md={1}>
                <TextField
                  disabled={disabled}
                  label="DH-O"
                  type="number"
                  name="dho"
                  value={formData?.dho}
                  onChange={handleChangevalue}
                  fullWidth
                  className="custom-textfield"
                  onKeyDown={(e) => {
                    if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                      e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                    }
                  }}
                />
              </Grid>

              <Grid item spacing={2} xs={12} sm={4.3} md={4.9}>
                <GooglePlaces
                  disabled={disabled}
                  width={'100%'}
                  onResult={onResultAddressDestination}
                  placeholder={'Destination (City/ST/ZIP) -'}
                  // regions={true}
                  address={formData?.destination?.address}
                  error={Boolean(errors.destination)}
                  helperText={errors.destination}
                />
                {!disabled && (
                  <div
                    style={{
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      marginTop: 5
                    }}
                    onClick={() => handleLocationIconClick('destination')}
                  >
                    <Iconify icon="mdi:location" style={{ color: '#010f58', fontSize: 20 }} />
                    <p style={{ fontSize: 13, color: '#666', marginLeft: 5 }}>
                      Set Location on map
                    </p>
                  </div>
                )}
              </Grid>

              {/* {!disabled && (
                <Grid
                  item
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: 1,
                    width: '20px'
                  }}
                >
                  <div
                    style={{ cursor: 'pointer' }}
                    onClick={() => handleLocationIconClick('destination')}
                  >
                    <Iconify icon="mdi:location" style={{ color: '#010f58', fontSize: 20 }} />
                  </div>
                </Grid>
              )} */}

              {/* <Grid item>
                <Iconify icon={'fa6-solid:right-left'} sx={{ fontSize: 12 }} />
              </Grid> */}
              {/* DH-D Field */}
              <Grid item xs={12} sm={1} md={1}>
                <TextField
                  disabled={disabled}
                  label="DH-D"
                  type="number"
                  name="dhd"
                  value={formData?.dhd}
                  onChange={handleChangevalue}
                  fullWidth
                  className="custom-textfield"
                  onKeyDown={(e) => {
                    if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                      e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                    }
                  }}
                />
              </Grid>
            </Grid>

            <Grid container spacing={2} mb={2} xs={12}>
              <Grid item spacing={2} xs={6}>
                <Grid item mb={2} xs={12}>
                  <TextField
                    disabled={disabled}
                    label="Origin/City"
                    type="text"
                    value={formData?.origin?.city || ''}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        origin: {
                          ...prev.origin,
                          city: e.target.value // ✅ yahan update hoga
                        }
                      }))
                    }
                    fullWidth
                    className="custom-textfield"
                    onKeyDown={(e) => {
                      if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                        e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                      }
                    }}
                  />
                </Grid>
                <Grid item container spacing={2} xs={12}>
                  <Grid item mb={2} xs={6}>
                    <TextField
                      disabled={disabled}
                      label="Origin/State"
                      type="text"
                      value={formData?.origin?.state || ''}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          origin: {
                            ...prev.origin,
                            state: e.target.value // ✅ yahan update hoga
                          }
                        }))
                      }
                      fullWidth
                      className="custom-textfield"
                      onKeyDown={(e) => {
                        if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                          e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                        }
                      }}
                    />
                  </Grid>
                  <Grid item mb={2} xs={6}>
                    <TextField
                      disabled={disabled}
                      label="Origin/Zip Code"
                      type="text"
                      value={formData?.origin?.zip_code || ''}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          origin: {
                            ...prev.origin,
                            zip_code: e.target.value // ✅ yahan update hoga
                          }
                        }))
                      }
                      fullWidth
                      className="custom-textfield"
                      onKeyDown={(e) => {
                        if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                          e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item spacing={2} xs={6}>
                <Grid item mb={2} xs={12}>
                  <TextField
                    disabled={disabled}
                    label="Destination/City"
                    type="text"
                    value={formData?.destination?.city || ''}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        destination: {
                          ...prev.destination,
                          city: e.target.value // ✅ yahan update hoga
                        }
                      }))
                    }
                    fullWidth
                    className="custom-textfield"
                    onKeyDown={(e) => {
                      if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                        e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                      }
                    }}
                  />
                </Grid>
                <Grid item container spacing={2} xs={12}>
                  <Grid item mb={2} xs={6}>
                    <TextField
                      disabled={disabled}
                      label="Destination/State"
                      type="text"
                      value={formData?.destination?.state || ''}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          destination: {
                            ...prev.destination,
                            state: e.target.value // ✅ yahan update hoga
                          }
                        }))
                      }
                      fullWidth
                      className="custom-textfield"
                      onKeyDown={(e) => {
                        if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                          e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                        }
                      }}
                    />
                  </Grid>
                  <Grid item mb={2} xs={6}>
                    <TextField
                      disabled={disabled}
                      label="Destination/Zip Code"
                      type="text"
                      value={formData?.destination?.zip_code || ''}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          destination: {
                            ...prev.destination,
                            zip_code: e.target.value // ✅ yahan update hoga
                          }
                        }))
                      }
                      fullWidth
                      className="custom-textfield"
                      onKeyDown={(e) => {
                        if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                          e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container spacing={2} mb={3}>
              <Grid container xs={12} sm={6}>
                <Grid
                  item
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginLeft: 2,
                    marginTop: 1
                  }}
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={['DatePicker']}>
                      <Grid item>
                        <DatePicker
                          minDate={dayjs()}
                          className="custom-textfield"
                          label="Pickup Earliest"
                          name="dateEarliest"
                          value={formData?.dateEarliest ? dayjs(formData?.dateEarliest) : null}
                          onChange={(newValue) => handleDateChange('dateEarliest', newValue)}
                          error={Boolean(errors.dateEarliest)}
                          // helperText={errors.dateEarliest}
                        />
                        {errors.dateEarliest && (
                          <p
                            style={{ fontSize: 12, color: '#FF4842', marginLeft: 18, marginTop: 3 }}
                          >
                            {errors.dateEarliest}
                          </p>
                        )}
                      </Grid>
                      <Grid item>
                        <DatePicker
                          minDate={dayjs()}
                          className="custom-textfield"
                          label="Pickup Latest"
                          name="dateLatest"
                          value={formData?.dateLatest ? dayjs(formData?.dateLatest) : null}
                          onChange={(newValue) => handleDateChange('dateLatest', newValue)}
                          error={Boolean(errors.dateLatest)}
                          // helperText={errors.dateLatest || ''}
                        />

                        {errors.dateLatest && (
                          <p
                            style={{ fontSize: 12, color: '#FF4842', marginLeft: 18, marginTop: 3 }}
                          >
                            {errors.dateLatest}
                          </p>
                        )}
                      </Grid>
                    </DemoContainer>
                  </LocalizationProvider>
                </Grid>
              </Grid>

              <Grid
                item
                spacing={2}
                xs={12}
                sm={6}
                sx={{ display: 'flex', justifyContent: 'space-between', marginTop: -1 }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={['TimePicker']}>
                    <Grid item>
                      <CustomTimePicker
                        disabled={disabled}
                        label="From"
                        name="timeStart"
                        value={formData?.timeStart} // Keep this as a moment object
                        onChange={(newValue) => handleTimeChange('timeStart', newValue)}
                        error={Boolean(errors?.timeStart)}
                        // helperText={errors?.timeStart}
                      />
                      {errors.timeStart && (
                        <p style={{ fontSize: 12, color: '#FF4842', marginLeft: 18, marginTop: 3 }}>
                          From time is required
                        </p>
                      )}
                    </Grid>
                    <Grid item>
                      <CustomTimePicker
                        disabled={disabled}
                        label="To"
                        name="timeEnd"
                        value={formData?.timeEnd}
                        onChange={(newValue) => handleTimeChange('timeEnd', newValue)}
                        error={Boolean(errors.timeStart)}
                        // helperText={errors.timeEnd}
                      />
                      {errors.timeStart && (
                        <p style={{ fontSize: 12, color: '#FF4842', marginLeft: 18, marginTop: 3 }}>
                          {/* {errors.timeStart} */}
                          To time is required
                        </p>
                      )}
                    </Grid>
                  </DemoContainer>
                </LocalizationProvider>
              </Grid>

              {formData.distance && (
                <Typography
                  sx={{ fontSize: 28, marginLeft: 2.3, mt: 1, color: 'gray', fontWeight: '700' }}
                >
                  {formData.distance} km
                </Typography>
              )}
            </Grid>

            <Typography
              variant="h6"
              sx={{
                marginTop: 2,
                borderBottom: '2px solid #010f58',
                paddingBottom: 0.5,
                marginBottom: 2,
                color: '#010f58'
              }}
            >
              {'Equipment Details'}
            </Typography>

            <RadioGroup
              sx={{ height: 30 }}
              row
              value={formData?.truckType}
              onChange={handleChangeRadio}
              name="truckType"
            >
              <FormControlLabel
                disabled={disabled}
                sx={{ fontSize: 12 }}
                value="Full"
                control={<Radio size="small" />}
                label={<Typography style={{ fontSize: '12px', color: '#010f58' }}>Full</Typography>}
              />
              <FormControlLabel
                disabled={disabled}
                sx={{ fontSize: 12 }}
                value="Partial"
                control={<Radio size="small" />}
                label={
                  <Typography style={{ fontSize: '12px', color: '#010f58' }}>Partial</Typography>
                }
              />
            </RadioGroup>
            <Typography variant="caption" color="error" sx={{ marginLeft: 1 }}>
              {errors.truckType}
            </Typography>

            <Grid container spacing={2} mb={2} mt={errors.truckType && 0}>
              {/* Equipment Type Dropdown */}
              <Grid item xs={4} md={6}>
                <TextField
                  disabled={disabled}
                  select
                  label="Equipment Type *"
                  name="equipmentType"
                  value={formData?.equipmentType || ''}
                  onChange={handleChangevalue}
                  fullWidth
                  error={Boolean(errors.equipmentType)}
                  helperText={errors.equipmentType}
                  InputLabelProps={{
                    shrink: true, // Force the label to shrink when a value is selected
                    style: {
                      fontSize: '11px',
                      lineHeight: '1.2',
                      transform: 'translate(14px, -6px) scale(1)' // Adjust position of label
                    }
                  }}
                  SelectProps={{
                    MenuProps: {
                      PaperProps: {
                        style: {
                          paddingTop: 0 // Ensure the dropdown aligns properly
                        }
                      }
                    }
                  }}
                  InputProps={{
                    style: {
                      fontSize: 14,
                      height: '50px', // Set the height of the input field
                      padding: '0px 0px' // Add padding to input field
                    }
                  }}
                >
                  {equipmentList.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%'
                        }}
                      >
                        <span
                          style={{
                            flex: 1,
                            textAlign: 'start',
                            display: 'flex',
                            fontWeight: 'normal',
                            marginRight: 10,
                            fontSize: 14
                          }}
                        >
                          {option.name}
                        </span>
                        <span
                          style={{
                            flex: 1,
                            width: '100%',
                            textAlign: 'right',
                            fontWeight: 'bold',
                            fontSize: 14,
                            color: '#000'
                          }}
                        >
                          {option.code}
                        </span>
                      </div>
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              {/* Length Input */}
              <Grid item xs={4} md={3}>
                <TextField
                  disabled={disabled}
                  type="number"
                  fullWidth
                  label={`Length (${formData?.length_unit}.) `}
                  name="length"
                  value={formData?.length}
                  onChange={handleChangevalue}
                  error={Boolean(errors.length)}
                  helperText={errors.length}
                  required
                  className="custom-textfield"
                  onKeyDown={(e) => {
                    if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                      e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <select
                        disabled={disabled}
                        value={formData?.length_unit} // Default to "ft" if not set
                        name="length_unit"
                        onChange={handleChangevalue}
                        style={{
                          border: 'none',
                          outline: 'none',
                          background: 'transparent',
                          cursor: 'pointer',
                          fontSize: 12
                        }}
                      >
                        <option value="ft">ft</option>
                        <option value="m">m</option>
                      </select>
                    )
                  }}
                />
                <p
                  style={{
                    fontSize: 11,
                    fontWeight: 'bold',
                    marginLeft: 15,
                    marginTop: 2,
                    color: 'gray',
                    letterSpacing: 0.5
                  }}
                >
                  {convertedLength ? `${convertedLength}` : ''}
                </p>
              </Grid>

              {/* Weight Input */}
              <Grid item xs={4} md={3}>
                <TextField
                  disabled={disabled}
                  type="number"
                  fullWidth
                  label={`Weight (${formData?.weight_unit}.)`}
                  name="weight"
                  required
                  value={formData?.weight}
                  onChange={handleChangevalue}
                  error={Boolean(errors.weight)}
                  helperText={errors.weight}
                  className="custom-textfield"
                  onKeyDown={(e) => {
                    if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                      e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                    }
                  }}
                  InputProps={{
                    endAdornment: (
                      <select
                        disabled={disabled}
                        value={formData?.weight_unit} // Default to "ft" if not set
                        name="weight_unit"
                        onChange={handleChangevalue}
                        style={{
                          border: 'none',
                          outline: 'none',
                          background: 'transparent',
                          cursor: 'pointer',
                          fontSize: 12
                        }}
                      >
                        <option value="kg">kg</option>
                        <option value="lbs">lbs</option>
                      </select>
                    )
                  }}
                />
                <p
                  style={{
                    fontSize: 11,
                    fontWeight: 'bold',
                    marginLeft: 15,
                    marginTop: 2,
                    color: 'gray',
                    letterSpacing: 0.5
                  }}
                >
                  {convertedWeight ? `${convertedWeight}` : ''}
                </p>
              </Grid>
            </Grid>

            <Grid container spacing={2} mb={2}>
              <Grid item xs={5} md={6}>
                <TextField
                  disabled={disabled}
                  label="Comment"
                  name="comment"
                  multiline
                  rows={6}
                  fullWidth
                  value={formData?.comment}
                  onChange={handleChangevalue}
                  error={Boolean(errors.comment)}
                  helperText={
                    errors.comment ||
                    `${formData?.comment?.length} / ${MAX_COMMENT_LENGTH} characters`
                  }
                  className="custom-textfield"
                  InputProps={{
                    shrink: true,
                    style: {
                      fontSize: 12,
                      padding: '10px 0px', // Add padding to input field
                      marginLeft: 3
                    }
                  }}
                />
              </Grid>
              <Grid item xs={5} md={6}>
                {/* <TextField
                  disabled={disabled}
                  sx={{ marginBottom: 5 }}
                  label="Commodity"
                  name="commodity"
                  fullWidth
                  value={formData?.commodity}
                  onChange={handleChangevalue}
                  error={Boolean(errors.commodity)}
                  helperText={errors.commodity}
                  className="custom-textfield"
                /> */}
                {/* COMMODITY */}
                <TextField
                  sx={{ marginBottom: 5 }}
                  disabled={disabled}
                  select
                  label="Commodity"
                  name="commodity"
                  value={formData?.commodity}
                  onChange={handleChangevalue}
                  fullWidth
                  error={Boolean(errors.commodity)}
                  helperText={errors.commodity}
                  InputLabelProps={{
                    shrink: true, // Force the label to shrink when a value is selected
                    style: {
                      fontSize: '11px',
                      lineHeight: '1.2',
                      transform: 'translate(14px, -6px) scale(1)' // Adjust position of label
                    }
                  }}
                  SelectProps={{
                    MenuProps: {
                      PaperProps: {
                        style: {
                          paddingTop: 0 // Ensure the dropdown aligns properly
                        }
                      }
                    }
                  }}
                  InputProps={{
                    style: {
                      fontSize: 14,
                      height: '50px', // Set the height of the input field
                      padding: '0px 0px' // Add padding to input field
                    }
                  }}
                >
                  {commondityList.map((option) => (
                    <MenuItem key={option.id} value={option.id}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          width: '100%'
                        }}
                      >
                        <span
                          style={{
                            flex: 1,
                            textAlign: 'start',
                            display: 'flex',
                            fontWeight: 'normal',
                            marginRight: 10,
                            fontSize: 14
                          }}
                        >
                          {option.name}
                        </span>
                      </div>
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  disabled={disabled}
                  label="Reference ID"
                  type="number"
                  name="referenceId"
                  fullWidth
                  value={formData?.referenceId}
                  onChange={handleChangevalue}
                  error={Boolean(errors.referenceId)}
                  helperText={errors.referenceId}
                  className="custom-textfield"
                  onKeyDown={(e) => {
                    if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                      e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                    }
                  }}
                />
              </Grid>
            </Grid>

            <Grid item xs={12} md={12} mb={2}>
              <Grid item xs={12} md={12}>
                <ProjectManagerDropdown
                  disabled={disabled}
                  label="Contact"
                  name="contact"
                  // value={selectedContact} // Always an array of IDs
                  // onChange={(e) => setSelectedContact(e.target.value)}
                  value={formData?.contact}
                  onChange={(e) => {
                    handleChangevalue(e);
                    setSelectedContact(e.target.value);
                  }}
                  showNameTag={false}
                  options={contactList.map((val) => ({
                    value: val?.id,
                    name: val?.contact_no
                  }))}
                  error={Boolean(errors.contact)}
                  helperText={errors.contact}
                  placeholder=""
                  labelFontMedium
                />
              </Grid>
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  mt: { xs: 0, md: 2 },
                  mb: { xs: 1 },
                  display: 'flex',
                  justifyContent: 'flex-end'
                }}
              >
                <Button
                  variant="contained"
                  style={{
                    height: 30,
                    width: 60,
                    borderRadius: 5,
                    letterSpacing: 0.5,
                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
                    transition: 'width 0.3s ease',
                    marginRight: 10
                  }}
                  height={30}
                  fontSize={12}
                  onClick={() => setContactAddModal({ open: true, mode: 'add', value: '' })}
                >
                  Add
                </Button>

                <Button
                  variant="contained"
                  disabled={formData.contact?.length == 1 ? false : true}
                  style={{
                    height: 30,
                    width: 60,
                    borderRadius: 5,
                    letterSpacing: 0.5,
                    boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.1)',
                    transition: 'width 0.3s ease'
                  }}
                  height={30}
                  fontSize={12}
                  onClick={() => {
                    const selectedId = selectedContact;
                    const selectedGroup = contactList.find((g) => g.id == selectedId);
                    setContactAddModal({
                      open: true,
                      mode: 'edit',
                      value: {
                        id: selectedGroup?.id,
                        name: selectedGroup?.contact_no || ''
                      }
                    });
                  }}
                >
                  Edit
                </Button>
              </Grid>
              {/* <TextField
                disabled={disabled}
                label="Contact"
                name="contact"
                type="number"
                fullWidth
                sx={{ maxWidth: '49%' }}
                value={formData?.contact}
                onChange={handleChangevalue}
                error={Boolean(errors.contact)}
                helperText={errors.contact}
                className="custom-textfield"
                onKeyDown={(e) => {
                  if (e.key === 'e' || e.key === 'E' || e.key === '+' || e.key === '-') {
                    e.preventDefault(); // Prevent "e", "E", "+", and "-" from being typed
                  }
                }}
              /> */}
            </Grid>
          </Box>
        </Collapse>
      </Box>

      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>

      {/* Map Dialog */}
      <Dialog open={mapOpen} onClose={() => setMapOpen(false)} maxWidth="md" fullWidth>
        <DialogContent>
          <LocationPickerMap
            open={mapOpen}
            onClose={() => setMapOpen(false)}
            locationType={locationType}
            selectedLocationFromForm={formData[locationType]}
            onSelectLocation={handleSelectLocation}
          />
        </DialogContent>
      </Dialog>

      {/* JOB GROUP ADD/EDIT MODAL */}
      <JobGroupEditAdd
        open={contactAddModal.open}
        mode={contactAddModal.mode}
        initialValue={contactAddModal.value}
        onSave={handleJobGroupSave}
        onClose={() => setContactAddModal({ ...contactAddModal, open: false })}
        // onDelete={...}
        saveLoading={saveLoading}
      />
    </Box>
  );
};

export default ShipmentDetailsForm;
